import './bankevent/style';
import FormStructure from './bankevent/form_structure';

export default FormStructure;